import type { OrganKind, ParticleType, Rule } from "./types";

export const RULES: Rule[] = [
  // Speichelamylase im Mund spaltet Stärke direkt zu Kohlenhydraten
  { organ: "mund", in: "brot", out: "kh" },
  // Magen + Pepsin → Fleisch-Brei
  { organ: "magen", in: "fleisch", out: "fleisch-brei" },
  // Leber-Galle emulgiert Öl
  { organ: "leber", in: "oel", out: "oel-tropfen" },
  // Pankreas spaltet Brei und Tropfen zu Endprodukten
  { organ: "pankreas", in: "fleisch-brei", out: "protein" },
  { organ: "pankreas", in: "oel-tropfen", out: "fett" },
];

export function transform(organ: OrganKind, input: ParticleType): ParticleType | null {
  const rule = RULES.find((r) => r.organ === organ && r.in === input);
  return rule?.out ?? null;
}

export const PARTICLE_COLORS: Record<ParticleType, number> = {
  brot: 0xe6b873,
  fleisch: 0xb84a4a,
  oel: 0xf0d040,
  "brot-brei": 0xc9a05a,
  "fleisch-brei": 0x8a3838,
  "oel-tropfen": 0xd9b838,
  kh: 0xf08a30,
  protein: 0x6a3020,
  fett: 0xf8e48a,
};

export const PARTICLE_LABELS: Record<ParticleType, string> = {
  brot: "Brot",
  fleisch: "Fleisch",
  oel: "Öl",
  "brot-brei": "Brot-Brei",
  "fleisch-brei": "Fleisch-Brei",
  "oel-tropfen": "Öltropfen",
  kh: "KH",
  protein: "Protein",
  fett: "Fett",
};
